import { config, msg } from 'api';
import errorHandler from 'lib/utils/errorHandler';
import { setSuccessMessage, setErrorMessage } from 'apps/notifications/actions/notifications';
import { filterDefaultPaymentTokens, filterOtherPaymentTokens } from 'apps/settings/utils/storedPaymentDetails';
import { pageEvents, pageStatistics } from 'apps/settings/analytics';
import { wa } from 'apps/analytics';

export const SET_PAYMENT_DETAILS = 'SET_PAYMENT_DETAILS';
export const SET_PAYMENT_METHOD_ERROR = 'SET_PAYMENT_METHOD_ERROR';

export function setPaymentDetails(paymentDetails, isPayPalPaymentEnabled) {
  return {
    type: SET_PAYMENT_DETAILS,
    isPayPalPaymentEnabled,
    ...paymentDetails,
  };
}

export function setPaymentMethodError(errorCode) {
  return {
    type: SET_PAYMENT_METHOD_ERROR,
    errorCode,
  };
}

export function getPaymentDetails() {
  return (dispatch, getState, { network }) => {
    const { user } = getState();
    const isPayPalPaymentEnabled = user.features.includes('PAYPAL_PAYMENTS');
    return network.get(`${config.apiBasePath}/settings/payment-details`)
      .then(response => dispatch(setPaymentDetails(response, isPayPalPaymentEnabled)))
      .catch(errorHandler);
  };
}

export function deletePaymentItem(id) {
  return (dispatch, getState, { network }) =>
    network.del(`${config.apiBasePath}/settings/payment-details/${id}`)
      .then(() => {
        dispatch(setSuccessMessage('Payment item deleted.'));
        return dispatch(getPaymentDetails()).then(
          response => {
            wa.triggerPageEventWithDescription(pageEvents.STORED_PAYMENT_DETAILS_DELETE_PAYMENT_SUCCESS_NOTIFICATION, {
              [pageStatistics.NUMBER_OF_USED_PAYMENT_TOKENS]: filterDefaultPaymentTokens(response.paymentTokens)
                .length,
              [pageStatistics.NUMBER_OF_NOT_USED_PAYMENT_TOKENS]: filterOtherPaymentTokens(response.paymentTokens)
                .length,
            });
          }
        );
      })
      .catch((errorResponse) => {
        wa.triggerPageEventWithDescription(pageEvents.STORED_PAYMENT_DETAILS_DELETE_PAYMENT_ERROR_NOTIFICATION);
        if (errorResponse.data && errorResponse.data.code) {
          return dispatch(setPaymentMethodError(errorResponse.data.code));
        }
        return dispatch(setErrorMessage(msg.settings.flashMessage.failure));
      });
}

export function updateUsages(usagesToUpdate) {
  return (dispatch, getState, { network }) =>
    network.post(`${config.apiBasePath}/settings/payment-details/usages`, {
      body: JSON.stringify({ usagesToUpdate }),
    })
      .then(() => {
        dispatch(setSuccessMessage('Payment usages updated.'));
        return dispatch(getPaymentDetails()).then((response) => {
          wa.triggerPageEventWithDescription(
            pageEvents.STORED_PAYMENT_DETAILS_SUCCESS_NOTIFICATION_DISPLAYED_AFTER_SAVING_PAYMENT_DETAILS, {
              [pageStatistics.NUMBER_OF_USED_PAYMENT_TOKENS]: filterDefaultPaymentTokens(response.paymentTokens)
                .length,
              [pageStatistics.NUMBER_OF_NOT_USED_PAYMENT_TOKENS]: filterOtherPaymentTokens(response.paymentTokens)
                .length,
            });
        });
      })
      .catch((errorResponse) => {
        wa.triggerPageEventWithDescription(
          pageEvents.STORED_PAYMENT_DETAILS_ERROR_NOTIFICATION_DISPLAYED_AFTER_SAVING_PAYMENT_DETAILS
        );
        if (errorResponse.data && errorResponse.data.code) {
          return dispatch(setPaymentMethodError(errorResponse.data.code));
        }
        return dispatch(setErrorMessage(msg.settings.flashMessage.failure));
      });
}

export function addUsage(paymentTokenId, usage) {
  return (dispatch, getState, { network }) =>
    network.put(`${config.apiBasePath}/settings/payment-details/${paymentTokenId}/usages`, {
      body: JSON.stringify({ usage }),
    })
      .then(() => {
        dispatch(setSuccessMessage('Payment usages updated.'));
        return dispatch(getPaymentDetails()).then(
          response => {
            wa.triggerPageEventWithDescription(
              pageEvents.STORED_PAYMENT_DETAILS_SUCCESS_NOTIFICATION_DISPLAYED_AFTER_USAGE_ADDITION, {
                [pageStatistics.NUMBER_OF_USED_PAYMENT_TOKENS]: filterDefaultPaymentTokens(response.paymentTokens)
                  .length,
                [pageStatistics.NUMBER_OF_NOT_USED_PAYMENT_TOKENS]: filterOtherPaymentTokens(response.paymentTokens)
                  .length,
              });
          }
        );
      })
      .catch((errorResponse) => {
        wa.triggerPageEventWithDescription(
          pageEvents.STORED_PAYMENT_DETAILS_ERROR_NOTIFICATION_DISPLAYED_AFTER_USAGE_ADDITION
        );
        if (errorResponse.data && errorResponse.data.code) {
          return dispatch(setPaymentMethodError(errorResponse.data.code));
        }
        return dispatch(setErrorMessage(msg.settings.flashMessage.failure));
      });
}

export function verifyCard() {
  return (dispatch, getState, { network }) => network.redirectTo({ to: '/settings/add-payment-type' });
}
